import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParCurrency from './par-currency';
import ParCurrencyDetail from './par-currency-detail';
import ParCurrencyUpdate from './par-currency-update';
import ParCurrencyDeleteDialog from './par-currency-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParCurrencyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParCurrencyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParCurrencyDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParCurrency} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParCurrencyDeleteDialog} />
  </>
);

export default Routes;
